module.exports = __webpack_public_path__ + "img/none_data.8270ac18.jpg";